export const allowedAttributes = {
    span: ['style'],
    a: [ 'href', 'name', 'target' ],
    p: [ 'style'],
    img: [ 'src', 'width', 'height', 'style' ],
    body: ['onload'],
    form: ["method", "action"],
    input: ["type", "name", "value"],
    doctype: ["html"]
}